import { createConfigLoader } from "@/config";
import eurIcon from "@/icons/currency/eur.svg";
import usdIcon from "@/icons/currency/usd.svg";
import { ICurrencyValue } from "@/types/currency.types";

// Interface for currency configuration
export interface ICurrencyConfig {
  currencies: ICurrencyValue[];
  defaultCurrency: string;
}

// Default currency configuration
const defaultCurrencyConfig: ICurrencyConfig = {
  currencies: [
    { label: "EUR", value: "EUR", icon: eurIcon, symbol: "€" },
    { label: "USD", value: "USD", icon: usdIcon, symbol: "$" },
  ],
  defaultCurrency: "EUR",
};

// Load configuration with country-specific overrides
const currencyConfigData = createConfigLoader(
  defaultCurrencyConfig,
  "currency",
);

// Export for backward compatibility
export const currencyConfig = new Map<string, ICurrencyValue>(
  currencyConfigData.currencies.map((currency) => [currency.value, currency]),
);

export const DEFAULT_CURRENCY = currencyConfigData.defaultCurrency;

// Export functions
export const getSupportedCurrencies = (): ICurrencyValue[] => {
  return currencyConfigData.currencies;
};
